"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummaryAddonSection = void 0;
const react_1 = __importDefault(require("react"));
const NumericFormatTwoDecimals_1 = require("../../numeric-format/NumericFormatTwoDecimals");
const SummaryAddonSection = (props) => {
    if (props.addons.length <= 0) {
        return null;
    }
    const addonRows = [];
    props.addons.forEach((addon) => {
        addonRows.push(react_1.default.createElement("tr", { key: addon.title },
            react_1.default.createElement("td", { className: "pt-0 small" }, addon.title),
            react_1.default.createElement("td", { className: "pt-0 small text-nowrap" }, addon.unit ? `${addon.quantity} ${addon.unit}` : ""),
            react_1.default.createElement("td", { className: "pt-0 small text-right" },
                react_1.default.createElement(NumericFormatTwoDecimals_1.NumericFormatTwoDecimals, { value: addon.price }))));
        if (addon.discount) {
            addonRows.push(react_1.default.createElement("tr", { key: `${addon.title}-discount`, className: "discount" },
                react_1.default.createElement("td", { className: "pt-0 small" },
                    "\u2517\u2501 ",
                    addon.discount.title),
                react_1.default.createElement("td", { className: "pt-0 small" }, addon.discount.percent ? `(${addon.discount.percent}%)` : ""),
                react_1.default.createElement("td", { className: "pt-0 text-right small" },
                    "-",
                    react_1.default.createElement(NumericFormatTwoDecimals_1.NumericFormatTwoDecimals, { value: addon.discount.calc(addon.price) }))));
        }
    });
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("tr", { key: "addon-title" },
            react_1.default.createElement("td", { className: "pb-0", key: "addon-title" }, props.title)),
        addonRows));
};
exports.SummaryAddonSection = SummaryAddonSection;
